console.log("NF AJAX CART FILE LOADED v12 - FAST");

document.addEventListener(
  "submit",
  function (e) {
    const form = e.target.closest(".ajax-cart-form");
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    nfHandleAjaxAddToCart(form);
  },
  true
);

document.addEventListener(
  "click",
  function (e) {
    const button = e.target.closest(".add-cart-btn");
    if (!button) return;

    const form = button.closest(".ajax-cart-form");
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    nfHandleAjaxAddToCart(form);
  },
  true
);

let nfCartBusy = false;

function nfHandleAjaxAddToCart(form) {
  if (nfCartBusy) return;
  nfCartBusy = true;

  const button = form.querySelector(".add-cart-btn");
  const originalHTML = button ? button.innerHTML : "";
  const formData = new FormData(form);

  if (button) {
    button.disabled = true;
    button.innerHTML = "מוסיף...";
  }

  fetch("/cart/add.js", {
    method: "POST",
    body: formData,
    headers: {
      Accept: "application/json"
    }
  })
    .then(function (res) {
      if (!res.ok) throw new Error("Cart add failed");
      return res.json();
    })
    .then(function () {
      return fetch("/cart?section_id=cart-drawer&t=" + Date.now(), {
        headers: {
          Accept: "text/html"
        }
      });
    })
    .then(function (res) {
      return res.text();
    })
    .then(function (html) {
      nfReplaceCartDrawer(html);
      nfOpenCartDrawer();
      nfFastUpdateBubbleFromDrawer();

      if (button) {
        button.innerHTML = "נוסף ✓";
      }
    })
    .catch(function (err) {
      console.error("NF AJAX ERROR:", err);

      if (button) {
        button.innerHTML = "שגיאה";
      }
    })
    .finally(function () {
      setTimeout(function () {
        if (button) {
          button.innerHTML = originalHTML;
          button.disabled = false;
        }

        nfCartBusy = false;
      }, 900);
    });
}

function nfReplaceCartDrawer(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const freshCartDrawerBox = doc.querySelector("#CartDrawer");
  const currentCartDrawer = document.querySelector("cart-drawer");
  const currentCartDrawerBox = document.querySelector("cart-drawer #CartDrawer");

  if (!freshCartDrawerBox || !currentCartDrawerBox || !currentCartDrawer) {
    console.error("NF drawer replace failed");
    return;
  }

  currentCartDrawerBox.innerHTML = freshCartDrawerBox.innerHTML;

  currentCartDrawer.classList.remove("is-empty");

  const drawerItems = currentCartDrawer.querySelector("cart-drawer-items");
  if (drawerItems) {
    drawerItems.classList.remove("is-empty");
  }

  const emptyContent = currentCartDrawer.querySelector(".drawer__inner-empty");
  if (emptyContent) {
    emptyContent.remove();
  }

  const checkoutBtn = currentCartDrawer.querySelector("#CartDrawer-Checkout");
  if (checkoutBtn) {
    checkoutBtn.disabled = false;
    checkoutBtn.removeAttribute("disabled");
  }
}

function nfOpenCartDrawer() {

  const drawer =
    document.querySelector('cart-drawer');

  if (!drawer) return;

  drawer.classList.add('active');
  drawer.classList.remove('is-empty');

  document.body.classList.add('overflow-hidden');

  const overlay =
    document.querySelector('#CartDrawer-Overlay');

  if (overlay) {

    overlay.onclick = function () {

      drawer.classList.remove('active');
      document.body.classList.remove('overflow-hidden');

    };

  }

  const closeBtn =
    drawer.querySelector('.drawer__close');

  if (closeBtn) {

    closeBtn.onclick = function () {

      drawer.classList.remove('active');
      document.body.classList.remove('overflow-hidden');

    };

  }

  const inner =
    drawer.querySelector('.drawer__inner');

  if (inner) {
    inner.setAttribute('tabindex', '-1');
    inner.focus();
  }

}

function nfFastUpdateBubbleFromDrawer() {

  fetch('/cart.js?t=' + Date.now())
    .then(function(res){
      return res.json();
    })
    .then(function(cart){

      const count = cart.item_count;

      const cartIcon =
        document.querySelector('#cart-icon-bubble');

      if(!cartIcon) return;

      let bubble =
        cartIcon.querySelector('.cart-count-bubble');

      if(!bubble && count > 0){

        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';

        cartIcon.appendChild(bubble);
      }

      if(count <= 0){

        if(bubble){
          bubble.remove();
        }

        return;
      }

      bubble.innerHTML =
        '<span aria-hidden="true">' +
        count +
        '</span>' +
        '<span class="visually-hidden">' +
        count +
        ' items</span>';

    })
    .catch(function(err){
      console.log(err);
    });

}